import { inject, Injectable } from '@angular/core';
import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { from, map, Observable } from 'rxjs';
import { UserDto } from '../Models/UserDto';
import { Roles } from '../Enums/Roles.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly keycloak = inject(Keycloak);

  public loadUserProfile(): Observable<UserDto> {
    return from(this.keycloak.loadUserProfile()).pipe(
      map((profile: KeycloakProfile) => ({
        name: profile.firstName || '',
        email: profile.email || '',
        username: profile.username || '',
      })),
    );
  }

  public logout(): void {
    this.keycloak.logout();
  }

  public login(): Promise<void> {
    return this.keycloak.login();
  }

  public isNotBinded(): boolean {
    const resourceAccess = this.keycloak.resourceAccess;
    if (resourceAccess) {
      return resourceAccess['portal-app'].roles.some(x => x.includes(Roles.PortalUserNotBinded));
    }
    return false;
  }

  public updateToken(): Promise<boolean> {
    return this.keycloak.updateToken(-1);
  }
}
